export const PRESET_SIZES = {
	lg: { w: 500, h: 500 },
} as const;

export const EXTENSION = 'png';

export const CONTENTS = [
	'ccd_rim_3dsm_125_1pc',
	'ccd_rim_3dsm_301_fx2',
	'ccd_rim_3dsm_305',
	'ccd_rim_3dsm_306',
	'ccd_rim_3dsm_30v2',
	'ccd_rim_3dsm_333',
	'ccd_rim_3dsm_335',
	'ccd_rim_3dsm_362',
	'ccd_rim_3dsm_366',
	'ccd_rim_bbs_cc',
	'ccd_rim_bbs_ch',
	'ccd_rim_bbs_ci',
	'ccd_rim_bbs_lm',
	'ccd_rim_bbs_rs',
	'ccd_rim_cosmis_mr7',
	'ccd_rim_cosmis_s1',
	'ccd_rim_cosmis_vcpn5r',
	'ccd_rim_cosmis_xt006r',
	'ccd_rim_cosmis_xt206r',
	'ccd_rim_fifteen52_holeshot',
	'ccd_rim_fifteen52_pentagt',
	'ccd_rim_hre_305',
	'ccd_rim_hre_935',
	'ccd_rim_hre_c109',
	'ccd_rim_hre_p200',
	'ccd_rim_hre_r101',
	'ccd_rim_hre_rs106',
	'ccd_rim_hre_s107',
	'ccd_rim_hre_s201h',
	'ccd_rim_loma_mcs',
	'ccd_rim_rotiform_blq_concave',
	'ccd_rim_rotiform_blqc',
	'ccd_rim_rotiform_bth',
	'ccd_rim_rotiform_cvt',
	'ccd_rim_rotiform_forged_ozr',
	'ccd_rim_rotiform_hur',
	'ccd_rim_rotiform_ind',
	'ccd_rim_rotiform_kb1',
	'ccd_rim_rtr_tech5',
	'ccd_rim_rtr_tech_mesh',
	'ccd_rim_ssr_ss',
	'ccd_rim_ssr_xr4',
	'ccd_rim_steel',
	'ccd_rim_turbofan_concave',
	'ccd_rim_turbofan_flat',
	'ccd_rim_vorsteiner_002',
	'ccd_rim_vorsteiner_163',
	'ccd_rim_vorsteiner_165',
	'ccd_rim_vorsteiner_310',
	'ccd_rim_vossen_cv3',
	'ccd_rim_work_equip_03',
	'ccd_rim_work_meister_l1',
	'ccd_rim_work_vsxx',
	'ccd_rim_work_xt7',
] as const;
